<template>
  <div class="wrap">

    <Head />
    <div class="part1">
      <p class="tit">区块链农渔产品溯源平台</p>
      <p class="txt">基于区块链技术并结合物联网、大数据等先进技术，将农产品从生产种植、加工、质检、物流、经销商、零售商的全流程信息记录上链，农业问题全链可追溯，形成良性循环的农业生态</p>
      <div class="img">
        <img
          src="../../../assets/images/mobile/solution/part1-3.png"
          alt=""
        >
      </div>
    </div>

    <div class="part2">
      <p class="tit">方案介绍</p>
      <div
        class="show"
        id="show"
        style="height:auto"
      >
        <div class="line">
          为解决农业产业链中层出不穷的农产品安全、产地造假、流程不透明、监管手段缺失等问题，恒为利用自主创新研发的区块链底层核心技术，建立农业区块链综合管理平台，实现农业生产、加工、运输、销售等过程中的数据公开及追溯。
        </div>
        <div class="line">
          恒为农业区块链综合管理平台，面向政府、企业、监管机构等，为农业产业中的各参与方提供安全、可信、易用的信息自动化采集、可信存证、设备管理、监管报送、溯源查询等服务。平台关键环节采用物联网技术自动采集产业链各环节数据并上链存证，大大降低人力成本；平台通过对各参与方进行身份认证，利用区块链技术防篡改的特性，实现链上数据有据可依；平台使得消费者由被动受益者变为溯源生态参与者。
        </div>
        <div class="line">
          平台旨在通过区块链技术，汇聚农业产业链中的大数据，帮助企业优化生产、提升政府监管效率、有效维护消费者权益。
        </div>
      </div>
      <div
        class="btn"
        v-show="show"
      >
        <div class="btn">
          <p
            @click="getChange('more')"
            v-show="more"
          >
            <span>查看更多</span>
            <i class="iconfont  iconxia"></i>
          </p>
          <p
            @click="getChange('less')"
            v-show="!more"
          >
            <span>收起</span>
            <i class="iconfont  iconshang"></i>
          </p>
        </div>
      </div>
      <div class="img">
        <img
          src="../../../assets/images/mobile/solution/agriculture/part2.png"
          alt=""
        >
      </div>

    </div>

    <div class="part3">
      <p class="tit">方案价值</p>
      <div class="center">
        <div class="card">
          <div class="left">
            <img
              src="../../../assets/images/mobile/solution/agriculture/part3-1.png"
              alt=""
            >
          </div>
          <div class="right">
            <p class="title">政府受益</p>
            <p class="text">
              农业产业链中的各个环节主体通过区块链密钥的方式将信息写入区块链，确保全流程公开透明，提高监管水平，实现政府的穿透式监管
            </p>
          </div>
        </div>

        <div class="card">
          <div class="left">
            <img
              src="../../../assets/images/mobile/solution/agriculture/part3-2.png"
              alt=""
            >
          </div>
          <div class="right">
            <p class="title">消费者受益</p>
            <p class="text">
              基于区块链防篡改、全链追溯的技术特性，全程溯源农产品从生产到销售的信息，有效保障消费者权益
            </p>
          </div>
        </div>

        <div class="card">
          <div class="left">
            <img
              src="../../../assets/images/mobile/solution/agriculture/part3-3.png"
              alt=""
            >
          </div>
          <div class="right">
            <p class="title">企业受益</p>
            <p class="text">
              资产转账速度快，仅需3-利用区块链技术对农产品生产线实施溯源改造，建立农产品供应方的品牌威信，提升农产品品牌价值，提高企业收益
            </p>
          </div>
        </div>
      </div>

    </div>

    <div class="part4">
      <p class="tit">产品核心功能</p>
      <div class="card">
        <div class="img">
          <img
            src="../../../assets/images/mobile/solution/agriculture/part4-1.png"
            alt=""
          >
        </div>
        <div class="content">
          <p class="title">呈信农产品区块链溯源平台</p>
          <div class="line">
            呈信农产品区块链溯源平台最大程度的利用区块链信息难以篡改、透明度高、信息可追溯的优势，结合物联网技术信息采集准确、节省人力的特点，将农业产业的种植养殖、种苗肥料、环境监控、生产日记、采摘甄选、包装物流、销售渠道、原产地追溯等相关信息形成完整的数据链条，提升农产品质量安全可信度，降低消费者维权监管成本和难度。通过品牌化和市场化运作转化农产品的商业机制，从而提高农民的收入。
          </div>
        </div>
      </div>
      <div class="card">
        <div class="content">
          <p class="title">庆渔堂</p>
          <div class="line">
            利用区块链技术对鱼塘养殖数据进行数据上链，基于区块链防篡改、公开透明的技术优势，记录养殖人员信息、养殖操作记录、饲料信息、鱼塘生态信息等。同时，平台结合物联网设备数据监控，实时监控鱼塘生态环境，如水质、土壤等情况，形成可溯源信息，以此保障出产的鱼类水产品品种健康安全，进而提升品牌效应，提高消费者的认可度。
          </div>
        </div>
      </div>
    </div>

    <Foot />
  </div>
</template>
<script>
import Head from "../../../components/mobile/Head.vue";
import Foot from "../../../components/mobile/Foot.vue";
export default {
  data() {
    return {
      show: false,
      more: true,
    };
  },
  components: {
    Head,
    Foot,
  },
  created() {},
  mounted() {
    this.getShow();
  },
  methods: {
    //判断是否显示加载更多
    getShow() {
      let h = document.getElementById("show").offsetHeight;
      let w = document.body.clientWidth;
      if (h > w * 0.31) {
        this.show = true;
        document.getElementById("show").style.height = "31vw";
      } else {
        this.show = false;
      }
    },
    getChange(type) {
      if (type == "more") {
        this.more = false;
        document.getElementById("show").style.height = "auto";
      } else {
        this.more = true;
        document.getElementById("show").style.height = "31vw";
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/css/mixin';

.wrap {
}

.part1 {
  height: vw(650);
  background: linear-gradient(-30deg, #39C2B7, #46D4BE);
  position: relative;
  part1();
  padding-top: vw(57);

  .tit {
    margin-bottom: vw(22);
    hTit();
  }

  .txt {
    font-size: vw(24);
    line-height: vw(36);
    text-align: center;
    color: #fff;
    padding: 0 vw(80);
  }

  .img {
    width: 100%;
    position: absolute;
    bottom: vw(20);
    text-align: center;

    img {
      width: vw(350);
      height: vw(309);
    }
  }
}

.part2 {
  part();
  background: #fff;

  .tit {
    tit3();
    margin-bottom: vw(30);
  }

  .show {
    overflow: hidden;
    transition: all 0.3s ease;

    .line {
      font-size: vw(28);
      color: #666666;
      line-height: vw(48);
      margin-bottom: vw(30);
      padding: 0 vw(30);
    }
  }

  .btn {
    margin-top: vw(40);

    p {
      width: vw(240);
      height: vw(80);
      background: #fff;
      border-radius: vw(40);
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
      text-align: center;
      margin: 0 auto;

      span {
        display: inline-block;
        height: vw(80);
        color: #2A93FF;
        font-size: vw(30);
        line-height: vw(80);
      }

      i {
        margin-left: vw(5);
        display: inline-block;
        height: vw(80);
        font-size: vw(24);
        color: #2A93FF;
        line-height: vw(80);
      }
    }
  }

  .img {
    margin-top: vw(60);
    text-align: center;

    img {
      width: vw(690);
      height: auto;
    }
  }
}

.part3 {
  part();
  background: rgba(249, 249, 249, 1);

  .tit {
    tit3();
    margin-bottom: vw(30);
  }

  .center {
    width: 100%;

    .card {
      display: flex;
      width: vw(690);
      height: vw(241);
      margin: 0 auto vw(30);
      padding: vw(44) vw(45) 0 vw(40);
      background: #fff;
      box-shadow: 0px 0px vw(10) 0px rgba(0, 0, 0, 0.1);

      .left {
        width: vw(179);
        margin-right: vw(37);
        padding-top: vw(14);

        img {
          width: 100%;
          height: auto;
        }
      }

      .right {
        flex: 1;

        .title {
          font-size: vw(32);
          line-height: vw(32);
          margin: vw(4) 0 vw(10);
          color: #444444;
        }

        .text {
          font-size: vw(24);
          color: #888;
          line-height: vw(36);
          showline(3)
        }
      }
    }
  }
}

.part4 {
  part();
  background: #fff;
  padding: vw(80) 0 vw(40);

  .tit {
    tit3();
    margin-bottom: vw(80);
  }

  .card {
    width: vw(690);
    padding: vw(20);
    margin: 0 auto vw(40);
    background: #fff;
    box-shadow: 0px 0px vw(10) 0px rgba(0, 0, 0, 0.1);

    .img {
      text-align: center;

      img {
        width: vw(650);
        height: auto;
      }
    }

    .content {
      margin-top: vw(60);

      .title {
        font-size: vw(32);
        font-weight: 500;
        color: rgba(68, 68, 68, 1);
        line-height: vw(32);
        margin-bottom: vw(30);
        text-align: center;
      }

      .line {
        font-size: vw(24);
        color: #888888;
        line-height: vw(36);
        margin-bottom: vw(40);
      }
    }
  }
}
</style>
